export enum BookmarkActionPostState {
  'Post' = 'POST',
  'Patch' = 'PATCH'
}

export enum BookMarkState {
  PreRegistered = 'pre-registered',
  Saved = 'saved',
  Applied = 'applied'
}

export type BookMarkActionNotificationToast = {
  content: React.ReactNode | string;
  duplicateContent: React.ReactNode | string;
};

export type BookmarkActionContext = { notificationToast?: BookMarkActionNotificationToast };

export type BookmarkAction = {
  id: string;
  contentId: string;
  postState: BookmarkActionPostState;
  options?: { label: BookMarkState };
  context?: BookmarkActionContext;
};
